import { render, staticRenderFns } from "./QuestionnaireComplete.vue?vue&type=template&id=1dc52c96&"
import script from "./QuestionnaireComplete.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports